import { Button } from "../../../components";
import { notification } from "../../../services";

const ImportarXmlActions = ({
  steps,
  activeStep,
  setActiveStep,
  dadosXml,
  isCadastro,
  setIsCadastro,
  setProdutos,
  produtosNaoCadastrados,
  handleInitStep,
  handleCadastrarFornecedor,
  handleCadastrarTransportadora,
  setLoading,
}) => {
  const handleVoltarStep = () => {
    if (activeStep > 0) {
      let stepAtual = activeStep;
      if (stepAtual == 4) {
        if (produtosNaoCadastrados.length === 0) {
          stepAtual--;
        }
        setProdutos((prevState) =>
          prevState.filter((item) => !item.usoConsumo)
        );
      }
      if (activeStep == 3) {
        if (!dadosXml?.transportadora?.cnpjCpf) {
          stepAtual--;
        }
        handleInitStep();
      }
      if (activeStep == 4) {
        setProdutos((prevState) =>
          prevState.filter((item) => !item.usoConsumo)
        );
        if (!dadosXml?.transportadora?.cnpjCpf) {
          stepAtual--;
          handleInitStep();
        }
      }
      setIsCadastro(false);
      setActiveStep(stepAtual - 1);
    }
  };

  const handleAvancarStep = async () => {
    setLoading(true);
    try {
      let proximoStep = activeStep + 1;
      let acaoExecutada = false;
      if (activeStep === 1 && !dadosXml?.transportadora) {
        await steps[1]?.funcaoAcao(dadosXml);
        const devePularCadastro = await steps[2]?.funcaoAcao(dadosXml);
        if (devePularCadastro) {
          proximoStep = 4;
        } else {
          proximoStep = 3;
        }
        acaoExecutada = true;
      }
      if (activeStep === 2 && !acaoExecutada) {
        const devePular = await steps[2]?.funcaoAcao(dadosXml);
        if (devePular) {
          proximoStep = 4;
        }
        acaoExecutada = true;
      }
      if (activeStep === 3 && !acaoExecutada) {
        if (!produtosNaoCadastrados || produtosNaoCadastrados.length === 0) {
          proximoStep = 4;
          acaoExecutada = true;
        } else {
          await steps[3]?.funcaoAcao(dadosXml);
          acaoExecutada = true;
        }
      }
      if (!acaoExecutada) {
        await steps[activeStep]?.funcaoAcao(dadosXml);
      }
      setActiveStep(proximoStep);
    } catch (error) {
      notification.alertaGenericos(
        error.message || "Ocorreu um erro inesperado."
      );
    } finally {
      setLoading(false);
    }
  };

  const switchCadastros = () => {
    switch (activeStep) {
      case 1:
        return handleCadastrarFornecedor();
      case 2:
        return handleCadastrarTransportadora();
      default:
        return handleAvancarStep();
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleVoltarStep}
        sx={{ width: "130px" }}
        startIcon={
          <i
            className="ph-fill ph-caret-left"
            style={{ color: "#fff", fontSize: 18 }}
          ></i>
        }
        disabled={activeStep === 0}
      >
        Voltar
      </Button>
      {isCadastro ? (
        <Button
          variant="contained"
          color="success"
          onClick={switchCadastros}
          sx={{ width: "135px" }}
          endIcon={
            activeStep === 3 && (
              <i
                className="ph-fill ph-caret-right"
                style={{ color: "#fff", fontSize: 18 }}
              ></i>
            )
          }
        >
          Cadastrar
        </Button>
      ) : (
        <Button
          variant="contained"
          onClick={handleAvancarStep}
          sx={{ width: "135px" }}
          endIcon={
            <i
              className="ph-fill ph-caret-right"
              style={{ color: "#fff", fontSize: 18 }}
            ></i>
          }
        >
          Próximo
        </Button>
      )}
    </>
  );
};

export default ImportarXmlActions;
